import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { from, Observable, of } from 'rxjs';
import { map, catchError, mergeMap, switchMap } from 'rxjs/operators';


import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';


import { SummaryPrivateFinancingModel } from '../../models/summary-private-financing.model';
import { PrivateFinancingService } from '../../services/private-financing.service';


import { LoadPrivateFinancing,LoadPrivateFinancingFailure,LoadPrivateFinancingSuccess,LoadPrivateFinancings,LoadPrivateFinancingsFailure,LoadPrivateFinancingsSuccess,UpdatePrivateFinancing,UpdatePrivateFinancingFailure,UpdatePrivateFinancingSuccess,DeletePrivateFinancing,DeletePrivateFinancingFailure,DeletePrivateFinancingSuccess, PrivateFinancingActionTypes } from '../actions/private-financing.actions';

@Injectable()
export class PrivateFinancingEffects {
  constructor(
    private actions$: Actions,
    private service: PrivateFinancingService
  ) { }

  /** 🔹 Get All */

  
  loadPrivateFinancings$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(PrivateFinancingActionTypes.LoadPrivateFinancings),
    mergeMap((action: LoadPrivateFinancings) =>
      this.service.getBySearch(action.payload.filter).pipe(
        map((res: PaginableResponseModel<SummaryPrivateFinancingModel>) => {
          if (!res || !res.isSuccess) {
              return new LoadPrivateFinancingsFailure({ error: 'No se pudo cargar la lista' });
            }
            return new LoadPrivateFinancingsSuccess({
              items: res.values,
              total: res.total
            });
          }),
          catchError(error => of(new LoadPrivateFinancingsFailure({ error })))
        )
      )
    ));


      /** 🔹 Get By Id */
      
      loadPrivateFinancingById$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(PrivateFinancingActionTypes.LoadPrivateFinancing),
        mergeMap((action: LoadPrivateFinancing) =>
          this.service.getById(action.payload.uid).pipe(
            map(response => new LoadPrivateFinancingSuccess(response)),
            catchError(error => of(new LoadPrivateFinancingFailure({ error })))
          )
        )
      ));

       /** 🔹 Update */
        
        updatePrivateFinancing$: Observable<Action> = createEffect(() => this.actions$.pipe(
          ofType(PrivateFinancingActionTypes.UpdatePrivateFinancing),
          mergeMap((action: UpdatePrivateFinancing) =>
            this.service.update(action.payload.privateFinancing).pipe(
              switchMap(updated => [
                new UpdatePrivateFinancingSuccess({ privateFinancing: updated }),
              ]),
              catchError(error => of(new UpdatePrivateFinancingFailure({ error })))
            )
          )
        ));

        /** 🔹 Delete */
        
        deletePrivateFinancing$: Observable<Action> = createEffect(() => this.actions$.pipe(
          ofType(PrivateFinancingActionTypes.DeletePrivateFinancing),
          mergeMap((action: DeletePrivateFinancing) =>
            this.service.delete(action.payload.uid).pipe(
              switchMap(() => [
                new DeletePrivateFinancingSuccess({ uid: action.payload.uid }),
              ]),
              catchError(error => of(new DeletePrivateFinancingFailure({ error })))
            )
          )
        ));



}
